package fr.frux.splash

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

/**
 * Frame finale du splash, réutilisée comme visuel de marque des écrans d'entrée en grand écran
 * (spec §6) : aucune image nouvelle.
 *
 * Le panneau reprend le fond crème du splash plutôt que la couleur de conteneur du thème : la
 * palette du logo est fixe, et sur le `primaryContainer` du thème sombre la couronne et le nom
 * disparaissaient (constaté en Chrome le 2026-09-12).
 */
@Composable
fun BoxScope.EntryBrandVisual() {
    Box(modifier = Modifier.fillMaxSize().background(FOND_SPLASH)) {
        FruxSplashLogo(t = { SplashTimeline.TOTAL }, modifier = Modifier.fillMaxSize())
    }
}
